<template>
  <div style="width: 100%; overflow-x: auto">
    <div :style="{ 'min-width': minWidth + 'px' }">
      <slot />
    </div>
  </div>
</template>
<script setup>
const { minWidth } = defineProps({
  minWidth: {
    type: Number,
    default: 0
  }
});
</script>
<style scoped lang="scss"></style>
